document.addEventListener('DOMContentLoaded', function() {


    // Fill in loan amount input
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loanAmount = urlParams.get('loan_amount');
    // console.log(loanAmount);

    document.querySelector('#loan_amount').value = loanAmount;

    // AJAX loading of product properties for dynamic text and images
    const richtextTitle = document.querySelector('#main .heading.h1');
    const noteDiv = document.querySelectorAll('main .rte');
    const quickNote = document.querySelectorAll('main .rte p');
    const productImg = document.querySelector('#product_image')
    const productTitle = document.querySelector('#product_title');
    const productInterestInput = document.querySelector('#product-title');
    
    // Fetching product handle to fetch product data
    const productHandle = window.location.pathname.split('/').pop();

    fetch(`/products/${productHandle}.json`).then(response => response.json()).then(data => {
        const product = data.product;
        // console.log(product);

      // Assigning response data
      productImg.src = product.image.src;
      productImg.alt = product.handle;
      

      // Applying response data
      productTitle.textContent = product.title;
      productInterestInput.value = product.title;
      console.log('Input', productInterestInput);
      richtextTitle.textContent = richtextTitle.textContent.replace(/"product"/, product.title);
      quickNote.forEach(paragraph => {
        paragraph.innerHTML = paragraph.innerHTML.replace(/"vendor"/gi, product.vendor).replace(/"product"/gi, `<span id="productTitleSpan">${product.title.toLowerCase()}</span>`).replace(/"collection"/gi, product.tags.toLowerCase());
      })
      
      richtextTitle.style.display = "block";
      productTitle.classList.remove('hide');
      noteDiv.forEach(div => {
        div.style.display = 'block';
      })     
      
      // Product metafield values 
      return fetchMetafields(productHandle);


    })
    .catch(error => console.error('Error fetching product:', error));
  


  
  // Accessing product Metafields
  function fetchMetafields(handle) {
    return fetch('https://b6c8b5-2.myshopify.com/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': 'd4b39c0d62ae2fd265ad204d0e2f8f95'
        },
      body: `
        {
          product(handle: "${handle}") {
            manufacturer: metafield(namespace: "custom", key: "manufacturer") {
                value
                key
              }
              model: metafield(namespace: "custom", key: "model") {
                value
                key
              }
              model_year: metafield(namespace: "custom", key: "model_year") {
                value
                key
              }
              serial_number: metafield(namespace: "custom", key: "serial_number") {
                value
                key
              }
              condition: metafield(namespace: "custom", key: "condition") {
                value
                key
              }
              machine_hours: metafield(namespace: "custom", key: "machine_hours") {
                value
                key
              }
              idle_hours: metafield(namespace: "custom", key: "idle_hours") {
                value
                key
              }
            }
          }
        `
      }) 
      .then(response => response.json())
      .then(data => {
        const metafields = data.data.product;

        // Fill out metafields in HTML
        let html = "<div class=metafield_container>"

        for (let metafield in metafields) {
          if (metafields[metafield] && metafields[metafield].value) {
            const keyRaw = metafields[metafield].key.split('_');
            
            const keyUpper = keyRaw.map(word => {
              return word[0].toUpperCase() + word.slice(1); 
            }).join(' ');

            html += `<p style="margin:0px" ><b>${keyUpper}:</b> ${metafields[metafield].value}</p>`
          }

          html += '</div>';

          noteDiv[1].innerHTML = html;
          noteDiv[1].classList.remove('hide');
        }

        if (data.errors) {
          console.error("GraphQL Errors:", data.errors);
          return;
        }
      })
      .catch(error => {
        console.error("There was an error fetching the product metafields:", error);
    });
  }



  // Query paramter additions for form completion page & Hubspot API data submission 
  document.querySelector('#contact_form').addEventListener('submit', function(e) {
      e.preventDefault();
    
      // Constructing the return URL based on form data for a personalized experience
      const returnUrl = `/pages/form-submitted/loan-form`;
      // console.log("Value:", document.querySelector('#product-title').value, "name:", document.querySelector('#product-title').name)
      // Collect form data and submit to Hubspot
      const formData = {
          fields: [
              {
                  objectTypeId: "contact",
                  name: document.querySelector('#contact-form-company_name').name,
                  value: document.querySelector('#contact-form-company_name').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#loan_form-typeofbusiness').name,
                value: document.querySelector('#loan_form-typeofbusiness').value
              },
              {
                  objectTypeId: "contact",
                  name: "firstname",
                  value: document.querySelector('#contact-form-fname').value
              },
              {
                  objectTypeId: "contact",
                  name: "lastname",
                  value: document.querySelector('#contact-form-lname').value
              },
              {
                objectTypeId: "contact",
                name: "mobilephone",
                value: document.querySelector('#contact-form-mobile_number').value
              },
              {
                  objectTypeId: "contact",
                  name: "email",
                  value: document.querySelector('#contact-form-email').value
              },
              {
                  objectTypeId: "contact",
                  name: document.querySelector('#loan_amount').name,
                  value: document.querySelector('#loan_amount').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#firstline_address').name,
                value: document.querySelector('#firstline_address').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#secondline_address').name,
                value: document.querySelector('#secondline_address').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#contact-form-city').name,
                value: document.querySelector('#contact-form-city').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#contact-form-state').name,
                value: document.querySelector('#contact-form-state').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#postal_code').name,
                value: document.querySelector('#postal_code').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#loan_form-notes').name,
                value: document.querySelector('#loan_form-notes').value
              },
              {
                objectTypeId: "contact",
                name: document.querySelector('#product-title').name,
                value: document.querySelector('#product-title').value
              }
          ]
      };

      // console.log("Value:", document.querySelector('#product-title').value, "name:", document.querySelector('#product-title').name)

      // console.log("This is the form data:", formData);
  
      // Submit to HubSpot
      fetch('https://api.hsforms.com/submissions/v3/integration/submit/43764379/ae8ed816-1218-45b2-b787-18477baf0b8e', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then(data => {
          console.log('Form submitted successfully!', data);
          console.log("This is the form data:", formData);
          // Handle success actions, maybe redirect or show a thank you message
          window.location.href = returnUrl;
      })
      .catch(error => {
          console.error('Error submitting form to HubSpot', error);
          // Handle error actions, maybe show an error message to the user
          alert('There was an issue submitting the form. Please check your entries and try again.');
  
      });
  });
    

});